export const initViewValuesBranch = {
  currentIndex: 0,
  bg: { background_0201: 'color' },
  bgImage: {
    background_0201: ['https://image.inappmessage.com/sample/undefined.png'],
    logo_0201: ['https://image.inappmessage.com/sample/heart.png']
  },
  bgColor: {
    close_0201: ['#ffffff'],
    background_0201: ['#000000']
  },
  deeplink: { button_0201: ['https://www.inappmessage.com/'] },
  radius: { button_0201: 8 },

  text: {
    title_0201: ['소중한 의견\n답변해주셔서 감사합니다'],
    sub_title_0201: [
      '고객님들의 남겨주시는 소중한 의견을 통해\n더 나은 서비스를 제공할 수 있도록\n개선하도록 하겠습니다.'
    ]
  },
  fontSize: { title_0201: 1.25, sub_title_0201: 0.75 },
  fontWeight: { title_0201: 700, sub_title_0201: 400 },
  color: { title_0201: '#ffffff', sub_title_0201: '#828282' },
  fontFamily: { title_0201: 'Montserrat', sub_title_0201: 'Montserrat' },
  textAlign: { title_0201: 'center', sub_title_0201: 'center' },

  btnText: { button_0201: ['다른 상품 보러가기'] },
  btnFontSize: { button_0201: 0.875 },
  btnFontWeight: { button_0201: 500 },
  btnColor: { button_0201: '#000000' },
  btnBgColorR: { button_0201: 255 },
  btnBgColorG: { button_0201: 255 },
  btnBgColorB: { button_0201: 255 },
  btnBgColorA: { button_0201: 1 },
  btnFontFamily: { button_0201: 'Montserrat' }
};

export const initTrackingValuesBranch = {
  tracking: {
    close_0201: ['close button 2'],
    button_0201: ['submit button 2']
  },
  logCustom: {}
};

export const initEditorValuesBranch = {
  contents_0201: {
    bgImageType: ['background_0201', 'logo_0201'],
    bgColorType: ['close_0201', 'background_0201'],
    bg: ['background_0201'],
    bgImage: ['logo_0201'],
    bgColor: ['close_0201'],

    textType: ['title_0201', 'sub_title_0201'],
    text: ['title_0201', 'sub_title_0201'],
    fontSize: ['title_0201', 'sub_title_0201'],
    fontWeight: ['title_0201', 'sub_title_0201'],
    color: ['title_0201', 'sub_title_0201'],
    fontFamily: ['title_0201', 'sub_title_0201'],
    textAlign: ['title_0201', 'sub_title_0201']
  },
  buttons_0201: {
    btnType: ['button_0201'],
    btnText: ['button_0201'],
    btnFontSize: ['button_0201'],
    btnFontWeight: ['button_0201'],
    btnColor: ['button_0201'],
    btnBgColor: ['button_0201'],
    btnFontFamily: ['button_0201'],
    deeplink: ['button_0201'],
    radius: ['button_0201'],
    radiusMax: [30]
  },
  trackings_0201: {
    trackingType: ['close_0201', 'button_0201']
  }
};
